export type IFormErrorFieldError = {
  [key: string]: string[]
}

export class FormError extends Error {
  constructor(private _fields: IFormErrorFieldError) {
    super('FormError');
  }

  public get fields(): IFormErrorFieldError {
    return this._fields;
  }
}
